module.exports = __webpack_public_path__ + "assets/img/RewardBodyBtn2.717aa0fb.png";